export const renameWelcomeTab = (tabs = [], type, label) =>
  tabs.map((tab) => (tab.type === type ? { ...tab, label } : tab));

export const resolveSavedWelcomeTabs = (saved, fallbackTabs) =>
  Array.isArray(saved?.welcome_tabs) ? saved.welcome_tabs : fallbackTabs;
